<template>
  <ul class="nav nav-mobile-menu">
    <li>
      <drop-down>
        <a slot="title" @click="logout()">
          <i class="material-icons">cancel</i>
          <p>Đăng xuất</p>
        </a>
      </drop-down>
    </li>
    <li>
      <drop-down>
        <a slot="title" href="/bill-management">
          <i class="material-icons">notifications</i>
          <span class="notification">{{ notifications.length }}</span>
          <p>đơn hàng chưa xác nhận</p>
        </a>
      </drop-down>
    </li>
  </ul>
</template>
<script>
import firebase from "@/services/firebase-init.js";
import "firebase/auth";
export default {
  props: ["notifications"],
  data() {
    return {
      search: null,
      selectedEmployee: null,
      employees: [
        "Jim Halpert",
        "Dwight Schrute",
        "Michael Scott",
        "Pam Beesly",
        "Angela Martin",
        "Kelly Kapoor",
        "Ryan Howard",
        "Kevin Malone",
      ],
    };
  },
  methods: {
    showBillDetail(item) {
      this.$emit("showBillDetailFromNotify", item);
    },
    logout() {
      let that = this;
      var r = confirm("Xác nhận đăng xuất khỏi hệ thống?");
      if (r == true) {
        firebase
          .auth()
          .signOut()
          .then(function () {
            that.$store.commit("RESET_LIST_PRODUCTS");
            localStorage.clear();
            that.$router.push("/");
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        //maybe show something to confirm user remaining logged-in
      }
    },
  },
};
</script>
